import { render, staticRenderFns } from "./AreaData.vue?vue&type=template&id=2adc7e0a&scoped=true&"
import script from "./AreaData.vue?vue&type=script&lang=js&"
export * from "./AreaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc7e0a",
  null
  
)

export default component.exports